/**
 * Kept apart from meetings.service.ts so that rendering a meeting — a table cell, a status chip — does not
 * drag the service and everything it depends on into the bundle. meetings.service.ts re-exports these,
 * so importing them from there stays valid.
 */

export enum MeetingStatus {
  CREATED = 'CREATED',
  TIMEOUT = 'TIMEOUT',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
  WAITING_FOR_RETRY = 'WAITING_FOR_RETRY',
  WAITING_TO_BE_QUEUED = 'WAITING_TO_BE_QUEUED',
  EXCLUDED = 'EXCLUDED',
  CANCELLED = 'CANCELLED',
  POSTPONED = 'POSTPONED',
}

export enum MeetingSessionStatus {
  QUEUED = 'QUEUED',
  WAITING_TO_START = 'WAITING_TO_START',
  CONNECTING = 'CONNECTING',
  WAITING_TO_BE_ADMITTED = 'WAITING_TO_BE_ADMITTED',
  CONNECTED = 'CONNECTED',
  PAUSED = 'PAUSED',
  HANGING_UP = 'HANGING_UP',
  ENDED = 'ENDED',
  ERRORED = 'ERRORED',
  TIMEOUT = 'TIMEOUT',
}

export enum MeetingType {
  LIVE = 'LIVE',
  SCHEDULED = 'SCHEDULED',
  AUDIO_UPLOAD = 'AUDIO_UPLOAD',
  VIDEO_UPLOAD = 'VIDEO_UPLOAD',
}

export enum MeetingProcessingStatus {
  PROCESSING_MEDIA = 'PROCESSING_MEDIA',
  PROCESSING_TRANSCRIPT = 'PROCESSING_TRANSCRIPT',
  PROCESSING_SPEAKERS = 'PROCESSING_SPEAKERS',
  GENERATING_MINUTES = 'GENERATING_MINUTES',
  GENERATING_AGENDA_ITEMS = 'GENERATING_AGENDA_ITEMS',
  GENERATING_OUTLINE = 'GENERATING_OUTLINE',
  SPLITTING_MEETING = 'SPLITTING_MEETING',
}

export type MeetingProvider = 'TEAMS' | 'ZOOM' | 'GMEET'

export type BatchJobType = 'TRANSCODER' | 'TRANSCRIBER' | 'LLM' | 'LLM_LIVE'

export type ConsentResponse = 'CONSENTED' | 'DECLINED' | 'DISMISSED'
